import React from 'react'
import dompurify from 'dompurify';

export const MultiGroupVoteSummary = ({ groups, groupVotes }) => {
    // Get summary
    const getGroupSummary = (group, groupVotes) => {
        if (!groupVotes || groupVotes.length === 0) {
            return <div className="italic mb-2">Skipped</div>
        }

        if (["BallotSingle", "BallotMulti"].includes(group.groupType)) {
            return [...groupVotes].sort((a, b) => a.ballotOptionId > b.ballotOptionId).map((vote) => {
                return <div key={vote.ballotOptionId} className="mb-2">{vote.ballotOptionName}</div>
            })
        }
        else if (group.groupType.startsWith("Ranked")) {
            return [...groupVotes].sort((a, b) => a.score < b.score).map((vote) => {
                return <div key={vote.ballotOptionId} className="mb-2">{vote.score} - {vote.ballotOptionName}</div>
            })
        }
        else if (group.groupType.startsWith("Questionnaire")) {
            return [...groupVotes].sort((a, b) => a.ballotOptionId > b.ballotOptionId).map((vote) => {
                return <div key={vote.ballotOptionId} className="mb-2">{vote.score === 1 ? "Yes" : "No"} - {vote.ballotOptionName}</div>
            })
        }
        else if (group.groupType.startsWith("Survey")) {
            return [...groupVotes].sort((a, b) => a.ballotOptionId > b.ballotOptionId).map((vote) => {
                return (
                    <div key={vote.ballotOptionId} className="mb-2" dangerouslySetInnerHTML={{ __html: dompurify.sanitize(vote.textValue + " - " + vote.ballotOptionName) }} />
                )
            })
        }

        return <div />
    }

    return (
        < React.Fragment >
            <div className="mb-4">A summary of your selections are displayed below.</div>
            {groupVotes && groups && Array.from(Object
                .keys(groups))
                .sort((a, b) => groups[a].order - groups[b].order)
                .map((groupId) => {
                    return (
                        <React.Fragment key={groupId}>
                            <div className="font-medium mb-4">{groups[groupId].groupName}</div>
                            {getGroupSummary(groups[groupId], groupVotes[groupId])}
                        </React.Fragment>
                    )
                })}
        </React.Fragment>
    )
}